var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minheight100"},[(_vm.appUser.isNative)?_c('app-header',{attrs:{"back-type":"back-app","title":"友邻少年"}}):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgmax",staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":require("../images//forever_vip_bg.png")}})])
}]

export { render, staticRenderFns }